<template>
<div class="dest-list c4">
  <ul>
    <li v-for="item in items">
      <img :src="item.photo" />
      <div>
        <h4>{{ item.title }}</h4>
        <p>{{ item.intro }}</p>
        <a class="lnk-more" :href="item.link">{{ item.readmore }}</a>
        <a class="whole-link" :href="item.link"></a>
      </div>
    </li>
  </ul>
</div>
</template>
<script>
export default {
  props: ["items"],
  mounted() {
    scrollAnimations(this.$el.parentNode);
  },
}
</script>
